import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { GAME_ADMIN_RESOURCES, GAME_ADMIN_SCOPES, PAGE_NAMES } from 'constant';
import EditConfigUpdate from './submodules/edit';

import ConfigUpdateList from './submodules/list';

const ConfigUpdateDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRouteV2
				configResourceName={GAME_ADMIN_RESOURCES.zkDashBoardUpdate}
				configActionName={GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkDashBoardUpdate].getDefaultValueForKey}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/list`}
				component={ConfigUpdateList}
				exact
			/>
			<AuthorizedRouteV2
				configResourceName={GAME_ADMIN_RESOURCES.zkDashBoardUpdate}
				configActionName={GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkDashBoardUpdate].updateZkKeyPartially}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/edit`}
				component={EditConfigUpdate}
				exact
			/>
			<AuthorizedRouteV2
				configResourceName={GAME_ADMIN_RESOURCES.zkDashBoardUpdate}
				configActionName={GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkDashBoardUpdate].promoteToProdDirectly}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/promoteOnProd`}
				component={EditConfigUpdate}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ConfigUpdateDashboard;
